import axios from 'axios';
import { PRODUCT_SEARCH_ES_URI } from '../../../constants';
import { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { TProductData } from './definitions';
import { getCloudImageUrl } from 'utils';
import { useGetViewType } from './useGetViewType';
import { convertBrandNameToSlug } from 'utils/Helpers';

export function useFetchSearchProductData(
  category: string,
  per_page: number,
  keyword: string,
) {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [data, setData] = useState<TProductData[]>([]);
  const [totalData, setTotalData] = useState(0);
  const [isEmpty, setIsEmpty] = useState(false);
  const { isMobileView } = useGetViewType();

  useEffect(() => {
    setIsFetching(true);
    axios
      .get(`${PRODUCT_SEARCH_ES_URI}`, {
        params: Object.assign(
          category === ''
            ? {}
            : {
                category,
              },
          {
            sort_by: 'most_popular',
            page: 1,
            availables: true,
            per_page: per_page,
            keyword,
          },
        ),
      })
      .then((response) => {
        const newValue = response.data.data.data.map((product) => {
          const brandSlug = convertBrandNameToSlug(product.brands?.[0]);

          return {
            id: product.id,
            image: getCloudImageUrl(product.image_url, 300),
            slug: product.slug,
            category: product.category,
            name: product.display_name,
            brand: brandSlug,
          };
        });
        setData(newValue);
        setTotalData(response.data.data.total);
        if (newValue.length === 0) {
          setIsEmpty(true);
        } else {
          setIsEmpty(false);
        }
        setIsFetching(false);
      })
      .catch((err) => {
        console.error('failed to fetch', err);
        setIsFetching(false);
      });
  }, [keyword]);

  return {
    isFetching,
    data,
    total: totalData,
    isEmpty,
  };
}
